import _classCallCheck from "/Users/tomi/Documents/projects/cf/react-vaadin-components/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/tomi/Documents/projects/cf/react-vaadin-components/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/tomi/Documents/projects/cf/react-vaadin-components/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/tomi/Documents/projects/cf/react-vaadin-components/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { CustomElementIs } from './CustomElement';
import '@vaadin/vaadin-form-layout';
import '@vaadin/vaadin-form-layout/vaadin-form-item';
export var FormLayout = /*#__PURE__*/function (_CustomElementIs) {
  _inherits(FormLayout, _CustomElementIs);

  function FormLayout() {
    _classCallCheck(this, FormLayout);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormLayout).apply(this, arguments));
  }

  return FormLayout;
}(CustomElementIs('vaadin-form-layout'));
export var FormItem = /*#__PURE__*/function (_CustomElementIs2) {
  _inherits(FormItem, _CustomElementIs2);

  function FormItem() {
    var _this;

    _classCallCheck(this, FormItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormItem).call(this));
    _this.attributeWhitelist = _this.attributeWhitelist.concat('colspan');
    return _this;
  }

  return FormItem;
}(CustomElementIs('vaadin-form-item'));